export enum KirjanpitajanRooli {
  TAVALLINEN = 1,
  SUPER = 2,
  TAVALLINEN_JA_HOLVI = 3,
}
